import { ConfigDataInterface } from './ConfigApiInterface';
import { Config_Person_PageMenu_ApiEnum } from './PersonDetailConfigApiInterface';

export enum Config_PersonAccountTransactions_ActionsMenu_ApiEnum {
    'NOTHING' = 'NOTHING',
}

export enum Config_PersonAccountTransactions_Modules_ApiEnum {
    'indications' = 'indications',
    'overview' = 'overview',
    'results' = 'results',
}

export enum Config_PersonAccountTransactions_ActionsOther_ApiEnum {
    'NOTHING' = 'NOTHING',
}

export enum Config_PersonAccountTransactions_PageSubMenu_ApiEnum {
    'NOTHING' = 'NOTHING',
}

export interface Config_PersonAccountTransactions_ApiInterface
    extends ConfigDataInterface<
        Config_PersonAccountTransactions_Modules_ApiEnum,
        Config_PersonAccountTransactions_ActionsMenu_ApiEnum,
        Config_PersonAccountTransactions_ActionsOther_ApiEnum,
        Config_Person_PageMenu_ApiEnum,
        Config_PersonAccountTransactions_PageSubMenu_ApiEnum
    > {
    _?: boolean;
}
